import React from 'react'
import '../App'

const Navbar = () => {
  return  <div className='navbar'>
    <h1> Football videos app ⚽</h1>
    </div>
  
}

export default Navbar